export function addStylesheet(url: string): Promise<void> {
	const element = document.createElement("link");
	element.rel = "stylesheet";
	element.href = url;

	return new Promise((resolve, error) => {
		document.body.appendChild(element);
	});
}

const addScript = (url: string) => {
	return new Promise<void>((resolve) => {
		const s = document.createElement("script");
		s.type = "text/javascript";
		s.src = url;
		s.onload = () => {
			resolve();
		};

		document.body.appendChild(s);
	});
}

export const addScripts = async (urls: string[]) => {
	for (const url of urls) {
		await addScript(url);
	}
}